import React from 'react';

const defaultColor = '#666';

export const Adjust = ({ fill = 'currentColor' }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="20"
        viewBox="0 0 512 512"
        fill={fill}
        fillRule="evenodd"
    >
        <path d="M490.667 405.333h-56.811C424.619 374.592 396.373 352 362.667 352s-61.931 22.592-71.189 53.333H21.333C9.557 405.333 0 414.891 0 426.667S9.557 448 21.333 448h270.144c9.237 30.741 37.483 53.333 71.189 53.333s61.931-22.592 71.189-53.333h56.811c11.797 0 21.333-9.557 21.333-21.333s-9.535-21.334-21.332-21.334zm-128 53.334c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.358 32-32 32zM490.667 64h-56.811c-9.259-30.741-37.483-53.333-71.189-53.333S300.736 33.259 291.477 64H21.333C9.557 64 0 73.557 0 85.333s9.557 21.333 21.333 21.333h270.144C300.736 137.408 328.96 160 362.667 160s61.931-22.592 71.189-53.333h56.811c11.797 0 21.333-9.557 21.333-21.333S502.464 64 490.667 64zm-128 53.333c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.358 32-32 32zM490.667 234.667H220.523c-9.259-30.741-37.483-53.333-71.189-53.333s-61.931 22.592-71.189 53.333H21.333C9.557 234.667 0 244.224 0 256c0 11.776 9.557 21.333 21.333 21.333h56.811c9.259 30.741 37.483 53.333 71.189 53.333s61.931-22.592 71.189-53.333h270.144c11.797 0 21.333-9.557 21.333-21.333.001-11.776-9.535-21.333-21.332-21.333zM149.333 288c-17.643 0-32-14.357-32-32s14.357-32 32-32 32 14.357 32 32-14.357 32-32 32z" />
    </svg>
);

export const Bed = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill={fill}
        fillRule="evenodd"
    >
        <path d="M1.5 0v3.852a.92.92 0 0 1 .398-.103h2.977V1.501c0-.415.336-.751.753-.751h4.868c.417 0 .754.336.754.75V6h-.75V4.875c0-.268-.227-.375-.375-.375H1.898c-.153 0-.398.111-.398.375V6H.75V0h.75zm1.875.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25z" />
    </svg>
);

export const SuitCase = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill={fill}
        fillRule="evenodd"
    >
        <path d="M7.36 2.25H6.25V0h-4.5v2.25H.64a.383.383 0 0 0-.39.377v7.523c0 .207.175.376.39.376H7.36c.214 0 .39-.168.39-.376V2.627a.384.384 0 0 0-.391-.377zM2.5.763h3v1.486h-3V.763zM7 9.776H1V3h6v6.776zm-3-.545a2.72 2.72 0 1 0 0-5.438A2.72 2.72 0 0 0 4 9.23zm-1.756-2.83c.146-.11.331.323.347.13.033-.202.087-.265.232-.39.036-.029.091-.026.125-.052.027-.022.041-.071.029-.116-.032-.134.305.116.233-.003-.082-.005-.112-.187-.143-.302-.169.05-.203-.207-.327-.144-.059.03-.08.274-.158.337-.037-.147-.174-.087-.176-.276-.001-.06.074-.23.121-.266.15-.115.295.122.465-.047-.088-.204-.329-.266-.255-.451A2.097 2.097 0 0 1 4 4.393c.617 0 1.168.269 1.555.691a.996.996 0 0 0-.2.04c-.075.022-.23.063-.218-.057.141-.023.06-.076.077-.076-.072-.17-.47-.122-.546.059-.016.085-.356.168-.242.223.141-.01.088.174.146.135.072-.061.031-.17.134-.184.141-.02.043.119.124.171-.051.058-.124.1-.162.17-.142-.137-.227.175-.388.1-.002.052-.001.105-.003.156-.068.003-.136.034-.195-.011-.047.045-.063.138-.059.204a.363.363 0 0 1 .232.028c.055-.148.273-.206.403-.146.061.029.13.132.162.157.117.093.059-.015.072-.119.05.037.072.085.132.11.06.026.11-.005.161.048-.045.066-.106.141-.171.16-.088.023-.397-.021-.456-.098.02-.015.041-.057.062-.072.049-.111-.18.044-.28.059-.121.018-.165-.007-.261.082-.14.13-.259.332-.134.505.141.198.44-.048.542.109.038.063.077.462.11.553.033.09.127.352.256.338.044-.005.123-.11.163-.141.089-.074.072-.061.095-.173.025-.112.061-.085.12-.172.039-.058.02-.146.042-.217.044-.14.398-.403.237-.395-.077.005-.195.046-.25-.015-.048-.05-.027-.195-.027-.263.044.066.1.13.125.203.086-.01.284-.078.25-.177-.031-.098-.205-.146-.251-.246.06-.03.341.111.423.172.127.092.216.213.328.314A2.116 2.116 0 0 1 4 8.631a2.1 2.1 0 0 1-1.087-.309c.022-.003.047-.004.068-.009.022-.11.043-.21.068-.314.036-.144.21-.422.243-.458.065-.064.302.071.253-.066-.176-.09-.245-.347-.469-.313-.13.02-.458-.454-.547-.217-.113-.06-.247-.105-.19-.273-.182.063-.214-.184-.095-.271zM7 11.25a.75.75 0 1 1-1.5 0zm-4.5 0a.75.75 0 1 1-1.5 0zm-.604-4.595c.019.023.029.05.06.069.103.061.214.061.306.14.091.08.083.19.229.215-.016.14-.074.159-.017.3.054.138.192.181.135.328-.062.161-.16.104-.105.304a2.107 2.107 0 0 1-.608-1.356z" />
    </svg>
);

export const Ticket = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="12"
        height="6"
        viewBox="0 0 12 6"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill={fill}
        fillRule="evenodd"
    >
        <path d="M0 0v.766l.754.766L0 2.266l.754.75-.754.75.754.78-.754.72V6h12V0H0zm2.625.75v.375h.75V.75h7.875v4.5H6.39V2.269h.782V1.53H4.89v.738h.766V5.25H3.375v-.375h-.75v.375H1.104l.715-.681-.766-.793.765-.761-.749-.745.749-.729-.78-.791h1.587zm.75 2.625h-.75v.75h.75v-.75zm5.438-.938a.563.563 0 1 0 0 1.126.563.563 0 0 0 0-1.126zm-5.438-.562h-.75v.75h.75v-.75z" />
    </svg>
);

export const Brick = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                id="tsko"
                d="M4.5 10.063v2.624h-3v-2.624h3zm5 0v2.624h-3v-2.624h3zm5 0v2.624h-3v-2.624h3zm-11 .874h-1v.876h1v-.876zm5 0h-1v.876h1v-.876zm5 0h-1v.876h1v-.876zm1-5.25v2.625h-3V5.688h3zm-10 0v2.625h-3V5.688h3zm5 0v2.625h-3V5.688h3zm-6 .875h-1v.875h1v-.875zm5 0h-1v.875h1v-.875zm-4-5.25v2.625h-3V1.313h3zm5 0v2.625h-3V1.313h3zm5 0v2.625h-3V1.313h3zm-11 .875h-1v.876h1v-.876zm5 0h-1v.876h1v-.876zm5 0h-1v.876h1v-.876z"
            />
        </defs>
        <use fill={fill} fillRule="nonzero" transform="translate(-1 -1)" xlinkHref="#tsko" />
    </svg>
);

export const RowList = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <path
                id="opal"
                d="M5.5 2.625H15v1.313H5.5V2.625zm0 3.938H15v1.312H5.5V6.562zm0 3.937H15v1.313H5.5V10.5zM1 2.625h2.5v1.313H1V2.625zm0 3.938h2.5v1.312H1V6.562zM1 10.5h2.5v1.313H1V10.5z"
            />
        </defs>
        <use fill={fill} fillRule="nonzero" transform="translate(-1 -2)" xlinkHref="#opal" />
    </svg>
);

export const Info = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="14"
        height="14"
        viewBox="0 0 14 14"
    >
        <defs>
            <path
                id="gs8whhrd3a"
                d="M7 0c3.865 0 7 3.135 7 7s-3.135 7-7 7-7-3.134-7-7 3.135-7 7-7zm0 1C3.691 1 1 3.691 1 7s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm.75 4.477v5.521h-1.5V6.477h-.499v-1H7.75zm0-2.479v1.5h-1.5v-1.5h1.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <g transform="translate(-742 -647) translate(157 230) translate(17) translate(0 31) translate(503 381) translate(65 5)">
                                    <use fill={fill} fillRule="nonzero" xlinkHref="#gs8whhrd3a" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Vip = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <defs>
            <path
                id="ktpiu5affa"
                d="M4.355 6.74C3.59 6.03 3.11 5.014 3.11 3.888 3.111 1.74 4.852 0 7 0c2.148 0 3.889 1.741 3.889 3.889 0 1.126-.479 2.14-1.244 2.85C12.2 7.783 14 10.292 14 13.222c0 .43-.348.778-.778.778-.43 0-.778-.348-.778-.778 0-3.007-2.437-5.444-5.444-5.444s-5.444 2.437-5.444 5.444c0 .43-.349.778-.778.778-.43 0-.778-.348-.778-.778 0-2.93 1.8-5.44 4.355-6.483zM7 6.221c1.289 0 2.333-1.044 2.333-2.333C9.333 2.6 8.29 1.556 7 1.556c-1.289 0-2.333 1.044-2.333 2.333C4.667 5.178 5.71 6.222 7 6.222z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-250 -310) translate(253 313)">
                    <use fill={fill} fillRule="nonzero" xlinkHref="#ktpiu5affa" />
                </g>
            </g>
        </g>
    </svg>
);

export const Cruise = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="18"
            height="16"
            viewBox="0 0 18 16"
        >
            <defs>
                <path
                    id="n9srestnwa"
                    d="M17.809 11.688H1.187v4.25H14.82c.633 0 1.256-.022 2.255-1.087l1.921-2.076c.004-.6-.528-1.088-1.187-1.088zm-.328 1.062l-1.312 1.415c-.62.663-.873.707-1.263.71H2.375V12.75h15.106zm-3.825.531c-.328 0-.594.238-.594.531 0 .294.266.532.594.532.328 0 .594-.238.594-.531 0-.294-.266-.532-.594-.532zm2.373-3.719c.329 0 .596.24.596.532 0 .292-.267.531-.596.531H1.188V9.562zm-1.184-2.124c.325 0 .592.238.592.53 0 .294-.267.532-.592.532H1.187V7.437zm-1.186-2.125c.326 0 .591.238.591.53 0 .294-.265.532-.591.532H1.187V5.312zm-7.722-4.25V4.25H4.75V1.062h1.188zm-2.968 0V4.25H1.78V1.062H2.97zm5.937 0V4.25H7.72V1.062h1.187zm2.969 0V4.25h-1.188V1.062h1.188z"
                />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-350 -356) translate(340 351) translate(9 4.6)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#n9srestnwa" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const AirPlane = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 18 18"
    >
        <defs>
            <path
                id="q8n8cqofpa"
                d="M15.322 5.299h-3.834L9.168.25H6.37l1.234 5.049H1.431C1.133 4.66.692 4.104.125 3.697v1.437c.403.511.656 1.15.656 1.853C.78 7.69.528 8.33.125 8.841v1.436c.567-.406 1.008-.962 1.306-1.602H7.61L6.37 13.75h2.797l2.33-5.074h3.821c.926 0 1.679-.756 1.679-1.688 0-.933-.75-1.689-1.677-1.689zm0 2.332h-4.494l-2.33 5.072h-.794l1.24-5.072H1.917c.03-.214.044-.427.044-.641 0-.214-.015-.428-.044-.641h7.021l-1.234-5.05h.792l2.32 5.047h4.505c.35 0 .634.288.634.642-.001.353-.287.643-.633.643z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <g transform="translate(-531 -180) translate(204 177) translate(317) translate(10 3) translate(1 2)">
                                <use fill={fill} fillRule="nonzero" xlinkHref="#q8n8cqofpa" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Bus = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="14"
        viewBox="0 0 16 14"
    >
        <defs>
            <path
                id="n4b5ygjrka"
                d="M14.751 4.951h-.91V2.536c0-.569-.602-.898-1.17-1.03 0 0-2.131-.516-4.622-.516-2.49 0-4.72.516-4.72.516-.62.157-1.17.461-1.17 1.03v2.415h-.91c-.31 0-.562.222-.562.495v1.98c1.088 0 1.123-1.485 1.123-1.485h.35v6.394c0 .57.523 1.031 1.168 1.031h.183v.485c0 .273.251.495.561.495.31 0 .561-.222.561-.495v-.485h6.734v.495c0 .273.251.495.56.495.31 0 .562-.222.562-.495v-.495h.183c.645 0 1.168-.461 1.168-1.03V5.94h.35s.035 1.485 1.123 1.485v-1.98c0-.273-.252-.495-.562-.495zm-2.033 7.425v.022l-9.436-.022v-2.97h9.436v2.97zm0-3.96H3.282v-2.97h9.436v2.97zM5.475 9.901c.465 0 .842.332.842.742s-.377.743-.842.743c-.465 0-.842-.332-.842-.743 0-.41.377-.742.842-.742zm5.05 0c.465 0 .842.332.842.742s-.377.743-.842.743c-.465 0-.842-.332-.842-.743 0-.41.377-.742.842-.742zm-2.476-7.92c2.298 0 4.308.475 4.337.482.167.04.28.095.332.13v1.863H3.282V2.59c.053-.032.16-.082.329-.126.021-.005 2.132-.483 4.438-.483zm2.195.742H5.756v.99h4.488v-.99z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-318 -144) translate(204 140) translate(102) translate(12 3.52)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#n4b5ygjrka" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Train = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="17"
        viewBox="0 0 16 17"
    >
        <defs>
            <path
                id="jx2taawqda"
                d="M3.5 2.938v8.437c0 .621.507 1.125 1.132 1.125h6.737c.625 0 1.131-.504 1.131-1.125V2.937c0-.62-.506-1.124-1.13-1.124H4.631c-.625 0-1.132.504-1.132 1.125zm7.875 0l-.006 8.437H4.625l.007-8.438h6.743zM10.25 4.062h-4.5v3.375h4.5V4.063zm-3.938 9L4.625 14.75h6.75l-1.688-1.688h1.688L15.313 17h-1.688L12.5 15.875h-9L2.375 17H.687l3.938-3.938h1.688zm0-3.937c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm3.375 0c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm-.562-3.938v1.125h-2.25V5.188h2.25zM6.312.125c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562zm3.375 0c.317 0 .563.255.563.563 0 .307-.246.562-.563.562-.316 0-.562-.255-.562-.563 0-.307.246-.562.563-.562z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-213 -142) translate(204 140) translate(8 1) translate(1 1)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#jx2taawqda" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Lion = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g fill={fill}>
                <g>
                    <g>
                        <g>
                            <path
                                d="M19.056 7.346c-1.617-.64-1.858-2.164-3.87-4.106-1.056-1.018-2.346-1.514-3.608-1.514-.4 0-.798.05-1.185.15-.978.25-1.455.756-1.646 1.017.41.092.809.282 1.114.767.25.399.291.943.142 1.445-.049.163-.117.292-.201.441.233-.036.47-.06.718-.06 1.336 0 2.772.52 4.196 1.498.798.547 1.603 1.153 2.8 1.153.895 0 1.465-.406 1.616-.568.07-.077.066-.168-.076-.223"
                                transform="translate(-225 -545) translate(218 542) translate(7 3) translate(0 2)"
                            />
                            <path
                                d="M5.35 5.474c-.388-.147-.712-.476-.712-.476.004-.176.413-.396.89-.396.229 0 .474.051.698.182-.13.3-.739.64-.876.69m3.086.384c.627-.287 1.155-1.204.792-1.788-.298-.48-.808-.56-1.41-.56-.144 0-.29.016-.514.032-.943.067-7.122.876-7.18.915-.046.032-.107.108-.056.297.048.18.277.526.914.73-.076.048-.294.086-.475.07-.307-.027-.478-.1-.478-.1s-.161 1.92.278 2.683c.278.485.617.426 1.313.46.593.032.787.092.981.295.114.119.224.346.121.351-.311-.004-.496-.024-.733-.018-.222.006-.414.022-.656.1-.223.074-.584.345-.737 1.19-.051.281-.14 1.104.097 1.28.089.065.363.072.806.072l.944.008c.197 0 .299-.062.425-.198.334-.36 1.057-1.007 2.243-1.455 1.687-.636 2.005-.968 2.63-1.734.74-.91.695-2.63.695-2.63M19.363 9.697c-.07.006-.152.036-.426.038-.765.002-2.231-.302-4.116-1.77-1.537-1.197-3.038-1.748-4.3-1.748-.5 0-.94.064-1.372.255-.055.825-.25 1.678-.819 2.447-.327.442-.617.753-.995 1.02 1.365.084 2.917.986 3.651 1.394 2.117 1.176 3.51 1.451 4.476 1.446 2.465-.013 3.791-1.804 3.995-2.795.044-.212.013-.296-.094-.287M14.996 13.78c-.822-.112-2.096-.42-4.346-1.759-.584-.347-1.086-.608-1.573-.826-.82-.366-1.528-.551-2.22-.551-.778.007-1.433.21-2.187.593-1.267.643-1.99 1.989-2.174 2.374-.07.145.02.197.103.203.579.04 1.523.208 2.725.68 1.748.686 3.265 1.413 5.155 1.473 2.32.073 4.096-1.243 4.558-1.867.126-.17.137-.295-.04-.32M12.882.904C12.2.42 11.03 0 9.657 0c-.547 0-1.123.075-1.71.257C5.79.927 4.879 2.365 4.6 3.1c.714-.09 2.45-.309 3.362-.321.102-.196.613-1.19 2.25-1.612.444-.114.85-.174 1.312-.174.395 0 .921.062 1.273.14.008.001.005 0 0 0 .142.025.202-.147.085-.23"
                                transform="translate(-225 -545) translate(218 542) translate(7 3) translate(0 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Time = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="6wodv5xvqa"
                d="M7 0C3.135 0 0 3.135 0 7s3.135 7 7 7 7-3.135 7-7-3.135-7-7-7zm0 1.166c3.217 0 5.833 2.617 5.833 5.834 0 3.217-2.616 5.834-5.833 5.834S1.167 10.217 1.167 7c0-3.217 2.616-5.834 5.833-5.834zM7.191 3h-1v4.641c0 .132.053.259.146.354.094.094.221.146.354.146l3.678-.002v-1l-3.178.002V3z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-560 -470) translate(560 460) translate(1 11)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#6wodv5xvqa" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Calendar = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="nd3y8wukka"
                d="M13.001 1H12.5V0h-1v1h-9V0h-1v1H1c-.552 0-1 .537-1 1.2v9.6c0 .663.448 1.2 1 1.2h12.001c.551 0 .999-.537.999-1.2V2.2c0-.663-.448-1.2-.999-1.2zM1 6h12v6H1V6zm8.229.718l.707.707-3.416 3.417c-.094.093-.221.146-.354.146-.133 0-.26-.052-.354-.146L4.064 9.093l.707-.707 1.395 1.395 3.063-3.063zM13 2l.021.031L13 5H1V2h12z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-670 -432) translate(670 430) translate(0 2) translate(1 1)">
                            <use fill={fill} fillRule="nonzero" xlinkHref="#nd3y8wukka" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const List = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
            <g fill={fill} fillRule="nonzero">
                <g>
                    <g>
                        <g>
                            <path
                                d="M.406 1.3h12.188c.224 0 .406-.291.406-.65 0-.359-.182-.65-.406-.65H.406C.182 0 0 .291 0 .65c0 .359.182.65.406.65zM.389 4.55h8.16c.215 0 .389-.291.389-.65 0-.359-.174-.65-.39-.65H.389C.175 3.25 0 3.541 0 3.9c0 .359.174.65.389.65zM12.594 6.5H.406C.182 6.5 0 6.791 0 7.15c0 .359.182.65.406.65h12.188c.224 0 .406-.291.406-.65 0-.359-.182-.65-.406-.65zM6.08 9.75H.42c-.232 0-.42.291-.42.65 0 .359.188.65.42.65h5.66c.232 0 .42-.291.42-.65 0-.359-.188-.65-.42-.65z"
                                transform="translate(-560 -432) translate(560 430) translate(0 2) translate(2 2)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const HollowHeart = ({
    fill = defaultColor,
    width,
    height,
}: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 13"
        fill="none"
    >
        <path
            d="M6.91549 1.64023L6.91551 1.64025L6.9192 1.63598C7.5667 0.887196 8.39988 0.528258 9.2169 0.528258C10.0333 0.528258 10.8637 0.886752 11.5126 1.63711L11.513 1.63761C12.8289 3.15527 12.8291 5.64323 11.5129 7.16218L11.5081 7.1677L11.5048 7.17174L6.55921 12.2828L1.4776 7.08337C0.170927 5.56343 0.174232 3.08266 1.48698 1.56866L1.4875 1.56806C2.11389 0.843309 2.93199 0.5 3.74811 0.5C4.60752 0.5 5.48617 0.880379 6.15067 1.6494L6.52457 2.08211L6.90349 1.65379L6.91549 1.64023Z"
            stroke={fill}
        />
    </svg>
);

export const FillHeart = ({
    fill = defaultColor,
    width,
    height,
}: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 13"
        fill="none"
    >
        <path
            d="M9.2169 0.0282584C8.24793 0.0282584 7.27897 0.455526 6.541 1.30893L6.529 1.32249C5.77303 0.447613 4.75807 0 3.74811 0C2.78614 0 1.83018 0.406921 1.10921 1.24111C-0.369736 2.94679 -0.369736 5.71498 1.10921 7.42179L6.561 13L11.8788 7.5043L11.8908 7.48961C13.3697 5.7828 13.3697 3.01574 11.8908 1.31006C11.1518 0.455526 10.1859 0.0282584 9.2169 0.0282584Z"
            fill={fill}
        />
    </svg>
);

export const Boat = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="t47q4et2xa"
                d="M14.994 4h-1.066l-2.351-2.801C10.948.365 10.565 0 9.531 0H1.01v1h2.1l-.743 3H0l1.006 3.966C1.285 8.585 1.676 9 2.533 9h9.152c.533 0 1.06-.02 1.906-1.033L16 5.033C16 4.462 15.551 4 14.994 4zM8.088 1h1.443c.555 0 .685.054 1.264.821L12.623 4H7.345l.743-3zM4.141 1h2.917l-.743 3H3.397l.744-3zm10.591 4l-1.911 2.327C12.259 8 12.056 8 11.686 8H2.533c-.308 0-.418-.038-.578-.369L1.288 5h13.444zM11 6c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-319 -255) translate(319 255) translate(0 4)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#t47q4et2xa" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Walk = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="a95wjuh6ca"
                d="M4.842 10.073l.67.743-3.535 3.199s.61.485.376.485h-1.25l-.189-.874 3.928-3.553zm1.33-6.489c.801 0 1.453.652 1.453 1.453 0 .038-1.078 4.738-1.078 4.738l1.244 1.37 1.741 2.863s.868.492.571.492h-1.5l-1.61-2.761L4.37 8.863c-.11-.12-.154-.285-.119-.444l.723-3.286L.947 7.148.5 6.253 5.466 3.77c.005-.002.01 0 .014-.002.207-.114.44-.184.692-.184zm2.175 1.17c.2.04.529.16.829.248.715.21 1.696.498 2.693.498v1c-1.142 0-2.202-.312-2.975-.539-.266-.079-.566-.191-.744-.227zM6.854.5c.414 0 .749.56.749 1.25S7.268 3 6.854 3s-.749-.56-.749-1.25S6.44.5 6.854.5z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g transform="translate(-354 -255) translate(353.5 254.5) translate(2.5 .5)">
                        <use fill={fill} fillRule="nonzero" xlinkHref="#a95wjuh6ca" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Difference = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <defs>
            <path
                id="w31zd2ou7a"
                d="M8 1C4.135 1 1 4.134 1 8s3.135 7 7 7 7-3.134 7-7-3.135-7-7-7zm0 1.167c3.217 0 5.833 2.617 5.833 5.833S11.217 13.833 8 13.833 2.167 11.216 2.167 8 4.783 2.167 8 2.167zm2.229 3.772L7.166 9.001 5.771 7.606l-.707.707 1.748 1.75c.094.094.221.146.354.146.133 0 .26-.053.354-.146l3.416-3.417-.707-.707z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g
                        fill={fill}
                        fontFamily="MicrosoftJhengHeiBold, Microsoft JhengHei"
                        fontSize="14"
                        fontWeight="bold"
                    >
                        <text transform="translate(-560 -395) translate(560 394) translate(12)">
                            <tspan x="5.5" y="15">
                                行程差別
                            </tspan>
                        </text>
                    </g>
                    <g transform="translate(-560 -395) translate(560 394) translate(0 1)">
                        <mask id="ig7f48ywnb" fill="#fff">
                            <use xlinkHref="#w31zd2ou7a" />
                        </mask>
                        <use fill={fill} fillRule="nonzero" xlinkHref="#w31zd2ou7a" />
                        <g fill={fill} mask="url(#ig7f48ywnb)">
                            <path d="M0 0H16V16H0z" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const Compare = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-222 -428) translate(222 428)">
                    <circle cx="10" cy="10" r="8.5" stroke={fill} />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M17.795 12.12h-6.712l2.034-2.028c.227-.226.228-.594.002-.82-.226-.228-.593-.23-.82-.003L9.27 12.29c-.226.226-.227.595 0 .822l3.029 3.02c.227.226.594.225.82-.002.225-.227.225-.595-.002-.821l-2.034-2.027h6.712c.32 0 .58-.26.58-.581 0-.32-.26-.58-.58-.58z"
                    />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M10.268 6.72H3.787l2.218-2.028c.248-.226.249-.594.002-.82-.246-.228-.646-.23-.894-.003L1.81 6.89c-.247.226-.248.595 0 .822l3.304 3.02c.247.226.648.225.894-.002.247-.227.246-.595-.002-.821L3.787 7.88h6.48c.35 0 .633-.26.633-.581 0-.32-.283-.58-.632-.58z"
                        transform="matrix(-1 0 0 1 12.523 0)"
                    />
                </g>
            </g>
        </g>
    </svg>
);

// export const Flag = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
//     <svg
//         xmlns="http://www.w3.org/2000/svg"
//         xmlnsXlink="http://www.w3.org/1999/xlink"
//         width="10"
//         height="15"
//         viewBox="0 0 10 15"
//     >
//         <defs>
//             <path
//                 id="qwvk2qrh5a"
//                 d="M4 2.5v-.999C4 1.224 3.776 1 3.5 1s-.5.224-.5.501V15h1V9h9l-2.521-3.187L13 2.5H4zm5.693 3.934L10.934 8H4V3.5h6.982L9.681 5.208l-.47.618.482.608z"
//             />
//         </defs>
//         <g fill="none" fillRule="evenodd">
//             <g>
//                 <g>
//                     <g>
//                         <g>
//                             <g>
//                                 <g transform="translate(-1214 -755) translate(157 230) translate(17) translate(0 506) translate(1035 18) translate(2 .5)">
//                                     <use fill={fill} fillRule="nonzero" xlinkHref="#qwvk2qrh5a" />
//                                 </g>
//                             </g>
//                         </g>
//                     </g>
//                 </g>
//             </g>
//         </g>
//     </svg>
// );

export const ArrowRight = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <path
                            d="M0 0H25V25H0z"
                            transform="translate(-387 -613) translate(219 613) matrix(-1 0 0 1 193 0)"
                        />
                        <path
                            fill={fill}
                            fillRule="nonzero"
                            d="M19.001 17.333l-6.705-6.643-6.705 6.643L4 15.758l7.5-7.431c.44-.436 1.153-.436 1.592 0l7.5 7.43-1.59 1.576z"
                            transform="translate(-387 -613) translate(219 613) matrix(-1 0 0 1 193 0) matrix(0 1 1 0 -.37 .37)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const ArrowLeft = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26">
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <path d="M0 0H25V25H0z" transform="translate(-219 -613) translate(219 613)" />
                    <path
                        fill={fill}
                        fillRule="nonzero"
                        d="M17.858 17l-5.747-5.694L6.364 17 5 15.65l6.43-6.37c.376-.373.986-.373 1.363 0l6.43 6.37L17.857 17z"
                        transform="translate(-219 -613) translate(219 613) matrix(0 1 1 0 -.889 .889)"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export const ArrowUp = ({ fill = defaultColor, className }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={20}
        height={20}
        viewBox="0 0 20 20"
        className={className}
    >
        <defs>
            <path
                id="ArrowUp_a"
                d="M14.47 6.97l1.06 1.06-5 5.002a.749.749 0 01-1.06 0l-5-5.002 1.06-1.06L10 11.44l4.47-4.47z"
            />
        </defs>
        <g transform="matrix(1 0 0 -1 0 20)" fill="none" fillRule="evenodd">
            <mask id="ArrowUp_b" fill={fill}>
                <use xlinkHref="#ArrowUp_a" />
            </mask>
            <use fill={fill} fillRule="nonzero" xlinkHref="#ArrowUp_a" />
            <g fill="none" mask="url(#ArrowUp_b)">
                <path d="M0 0h20v20H0z" />
            </g>
        </g>
    </svg>
);

export const ArrowDown = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...props} fill="currentColor">
        <path d="M34.727 16.727l2.546 2.546-12 12.004a1.8 1.8 0 01-2.546 0l-12-12.004 2.546-2.546L24 27.457l10.727-10.73z" />
    </svg>
);

export const TagsFilter = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={34} height={34} viewBox="0 0 34 34">
        <g fill="none" fillRule="evenodd">
            <circle cx={17} cy={17} r={17} fill="#3EA5D9" />
            <g fill="#FFF" fillRule="nonzero">
                <path d="M25.575 11.771l-1.309-1.308 1.574-1.561a.528.528 0 00-.743-.749L23.52 9.718l-1.286-1.286c-.467-.467-1.196-.558-1.815-.227l-2.387 1.247c-.618.327-.1-.105-9.658 9.45-.488.487-.493 1.24-.048 1.685l5.09 5.088c0-.015.258.325.798.325.316 0 .639-.125.887-.373l8.862-8.859c.483-.483.528-.674 1.84-3.182.33-.619.24-1.348-.228-1.815zm-.703 1.319l-1.25 2.39c-.23.428.398-.26-9.267 9.401-.106.106-.208.048-.193.048-5.462-5.46-5.11-5.084-5.107-5.148.005-.11-.547.478 8.927-8.992.337-.337.37-.314 2.928-1.65.244-.128.459-.081.578.039l1.284 1.283-.771.766c-1.29-.722-2.884.211-2.884 1.69 0 1.077.873 1.935 1.937 1.935 1.488 0 2.407-1.601 1.692-2.88l.772-.765 1.312 1.31c.136.137.153.367.042.573zm-2.935-.174c0 .782-.953 1.177-1.507.624a.88.88 0 010-1.247c.554-.554 1.507-.16 1.507.623z" />
                <path d="M17.054 14.162l-5.892 5.891a.555.555 0 00.784.785l5.892-5.891a.555.555 0 00-.784-.784zm-.019 4.004l-3.87 3.869a.567.567 0 000 .8c.221.22.579.22.8 0l3.87-3.87a.567.567 0 000-.8.567.567 0 00-.8 0z" />
            </g>
        </g>
    </svg>
);

export const Magnifier = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <g fill="none" fillRule="nonzero">
            <path
                fill={fill}
                d="M10.306 9.259l3.144 3.143a.74.74 0 1 1-1.048 1.048L9.26 10.306a5.556 5.556 0 1 1 1.048-1.048zm-4.417.704a4.074 4.074 0 1 0 0-8.148 4.074 4.074 0 0 0 0 8.148z"
            />
            <path d="M-1-1h16v16H-1z" />
        </g>
    </svg>
);

export const Star = ({ fill = defaultColor }: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 14 13"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            stroke={fill}
            fill={fill}
            transform="translate(-19 -12)"
            d="m26 22-3.527 1.854.674-3.927-2.853-2.781 3.943-.573L26 13l1.763 3.573 3.943.573-2.853 2.781.674 3.927z"
        />
    </svg>
);

export const Pin = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            viewBox="0 0 12 14"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
            {...props}
        >
            <path
                d="M6 0C2.686 0 0 2.601 0 5.81c0 1.48.572 2.831 1.513 3.857a.585.585 0 00.094.118l3.889 3.944a.59.59 0 00.182.167.615.615 0 00.767-.066.58.58 0 00.123-.172l3.818-3.873c.03-.029.057-.06.08-.094A5.687 5.687 0 0012 5.811C12 2.6 9.314 0 6 0zm-.003 8.192c-1.34 0-2.425-1.051-2.425-2.348s1.086-2.348 2.425-2.348c1.34 0 2.425 1.05 2.425 2.348 0 1.297-1.085 2.348-2.425 2.348z"
                fillRule="nonzero"
            />
        </svg>
    );
};
